export class RequestOptions {
    Id_app: number = undefined;
    Id_session: string = undefined;
    Id_user: number = undefined;
    ManualJSON: number = undefined;
    signature: string = undefined;
    Controller0: string = undefined;
    EntityId0: number = undefined;
    Controller1: string = undefined;
    EntityId1: number = undefined;
    Controller2: string = undefined;
    EntityId2: number = undefined;
    Controller3: string = undefined;
    EntityId3: number = undefined;
    Section: string = undefined;
    Method: string = undefined;
    ApiVersion: string = undefined;
    Email: string = undefined;
    HPassword: string = undefined;
    Filtr: number;
    Id: number;
    Page: number;
    PageSize: number;
    Sort: string;
    IsShort: number;
    IsExcluded: number;
    IsFavorite: number;
    HOldPassword: string;
    HNewPassword: string;
    Name: string;
    ReadMessage: number;
    D_Payment: string;
    Id_PaymentType: number;
    Amount: number;
    qfiltr: string | undefined;
    sectionstring: string | undefined;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/request-options.ts